import React from 'react'
import { LegalIssuingSec } from './legalIssuingSec'

export const LegalIssuing = () => {
  return (
   <>
   <LegalIssuingSec />
   </>
  )
}

